import OneRouter from 'one-router';
import { initializeAlertRibbon } from './global/alert-ribbon.js';
import { initializeBackgroundVideos } from './global/background-video.js';
import { initializeBackToTop } from './global/back-to-top.js';
import { initializeExternalLinks } from './global/external-links.js';
import { initializeFixedHeader } from './global/fixed-header.js';
import { initializeGlobalNavigation } from './global/navigation.js';
import { loadNearViewport } from './global/load-near-viewport.js';
import { initializeSmoothScrolling } from './global/smooth-scrolling.js';

initializeGlobalNavigation();
initializeFixedHeader();
initializeExternalLinks();
initializeSmoothScrolling();
initializeBackToTop();
initializeAlertRibbon();
initializeBackgroundVideos();

// Load carousel code shortly before a carousel enters the viewport.
loadNearViewport(
  '[data-gallery-carousel], [data-property-carousel], .banner-carousel, .testimonials-carousel',
  () => {
    import('./components/carousels.js').then(({ initializeCarousels }) => initializeCarousels());
  },
  '100px 0px',
);

loadNearViewport('.gallery, .open-popup-link', () => {
  import('./components/lightbox.js').then(({ initializeLightbox }) => initializeLightbox());
}, '100px 0px');

loadNearViewport('[data-aos]', () => {
  import('./components/scroll-animations.js').then(({ initializeScrollAnimations }) => initializeScrollAnimations());
}, '400px 0px');

loadNearViewport('.js-tabs', () => {
  import('./components/accordion-tabs.js').then(({ initializeAccordionTabsAccessibility }) =>
    initializeAccordionTabsAccessibility(),
  );
}, '400px 0px');

loadNearViewport('.js-video-facade', () => {
  import('./components/video-facades.js').then(({ initializeVideoFacades }) =>
    initializeVideoFacades(),
  );
}, '100px 0px');

loadNearViewport('[data-property-map]', () => {
  import('./components/property-maps.js').then(({ initializePropertyMaps }) =>
    initializePropertyMaps(),
  );
}, '400px 0px');

if (
  !window.CSS?.supports('animation-timeline', 'view()')
  && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
) {
  loadNearViewport('.parallax', () => {
    import('./components/parallax-banners.js').then(({ initializeParallaxBanners }) =>
      initializeParallaxBanners(),
    );
  }, '100px 0px');
}

// OneRouter matches the current URL against each regular-expression string.
// Dynamic imports create separate chunks, so page code is downloaded only
// when its route matches.
new OneRouter({
  '^/contact/?$': () => import('./pages/contact.js').then(({ default: init }) => init()),
  '^/calendar(?:/.*)?$': () =>
    import('./pages/calendar.js').then(({ default: init }) => init()),
});
